import { where } from 'firebase/firestore'

import FirestoreService from '../../firestoreService'

import { getConvertedData } from '../../../models/interface.helper'

import { RegistrationFeesModel } from '../../../models/registration-fees/registrationFees.model'
import { IRegistrationFeesInterface } from '../../../models/registration-fees/registrationFees.interface'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

export const getByEventId = async (eventId: string) => {
  const registrationFees: IRegistrationFeesInterface[] = []

  const registrationFeesSnaps = await FirestoreService.filterItems(
    COLLECTIONS.REGISTRATION_FEES.NAME,
    [where(COLLECTIONS.REGISTRATION_FEES.FIELDS.EVENT_ID.KEY, '==', eventId)]
  )

  registrationFeesSnaps.docs.forEach((doc) => {
    registrationFees.push(getConvertedData(RegistrationFeesModel.fromFirestoreDoc(doc).toObject()))
  })

  return registrationFees
}

const RegistrationFeesService = {
  getByEventId,
}

export default RegistrationFeesService
